const cdnGamesUrl = 'https://cdn-assets.teuteuf.fr/data/teuteuf-games';
const iconSlugOverrides: Record<string, string> = {
  T30: 'thursday_thirty'
};

export type PassportGame = {
  name: string;
};

export const passportGames: PassportGame[] = [
  { name: 'Worldle' },
  { name: 'WhereTaken Classic' },
  { name: 'WhereTaken US' },
  { name: 'Statele' },
  { name: 'Flagle' },
  { name: 'Emovi' },
  { name: 'Angle' },
  { name: 'Challenge' },
  { name: 'Francele' },
  { name: 'Geozee' },
  { name: 'Historicale' },
  { name: 'Travle' },
  { name: 'Mapster' },
  { name: 'GeoConnections' },
  { name: 'Searchle' },
  { name: 'GeoGrid' },
  { name: 'WhenTaken' },
  { name: 'WhereTaken' },
  { name: 'WhenTaken Movies' },
  { name: 'T30' }
];

export const passportStackGameNames = ['T30', 'Travle', 'GeoGrid', 'Flagle', 'Worldle'] as const;
const fallbackStackGameName = 'WhenTaken';

const gamesByNormalizedName = new Map(
  passportGames.map((game) => [normalizeGameName(game.name), game])
);

function normalizeGameName(name: string): string {
  return name.toLowerCase().replace(/[^a-z0-9]/g, '');
}

export function findPassportGame(name?: string): PassportGame | undefined {
  return name ? gamesByNormalizedName.get(normalizeGameName(name)) : undefined;
}

export function getPassportStackGames(referer?: string): PassportGame[] {
  const games = passportStackGameNames
    .map((name) => findPassportGame(name))
    .filter((game): game is PassportGame => Boolean(game));
  const referrerGame = findPassportGame(referer);
  const fallbackGame = findPassportGame(fallbackStackGameName);
  const lastGame = referrerGame && !games.includes(referrerGame) ? referrerGame : fallbackGame;

  if (lastGame) games.push(lastGame);
  return games;
}

export function getGameIconUrl(gameName: string): string {
  const slug = iconSlugOverrides[gameName] ?? gameName.split(' ').join('_').toLowerCase();
  return `${cdnGamesUrl}/icons/${slug}.svg`;
}
